import { setSpecificMessage, bic } from "valibot";
setSpecificMessage(
  bic,
  (issue) => `BIC invalide: reçu ${issue.received}`,
  "fr"
);